import * as React from "react";
import { ResourceDWR } from "../../../../dto/SuggestionResult";
import { LibraryThing } from "@tlc/ls2pac/app/widget/LibraryThingWidget";

export interface BookjacketProps {
  resource: ResourceDWR;
}

export const Bookjacket: React.FC<BookjacketProps> = ({ resource }) => {
  const bookjacketId = `bookjacket_${resource.id}`;
  React.useEffect(() => {
    $(`#${bookjacketId}`).addCoverArt(
      LibraryThing.enums.requestType.bookJacketSmall,
      [resource],
      0,
      true,
      true
    );
  }, []);

  return (
    <div className="imgContainer">
      <div id={bookjacketId} className="bookjacket dropShadow"></div>
    </div>
  );
};
